var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHr = function SvgHr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hr_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 12.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 6 7.16 6 9.4 6h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C29 9.04 29 10.16 29 12.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C25.96 26 24.84 26 22.6 26H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 22.96 3 21.84 3 19.6z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hr_svg__b)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 6h30v20H1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A47B8",
    fillRule: "evenodd",
    d: "M1 19.333h30V26H1z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    fillRule: "evenodd",
    d: "M1 6h30v6.667H1z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A99FF",
    fillRule: "evenodd",
    d: "M12.429 11.333h1.428v1.334H12.43zM15.286 10h1.428v2.667h-1.428zm2.857 1.333h1.429v1.334h-1.429z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A47B8",
    fillRule: "evenodd",
    d: "M16.715 10h1.428v2.667h-1.428zm-2.858 0h1.429v2.667h-1.429z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "hr_svg__c",
    width: 8,
    height: 9,
    x: 12,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.572 17.333c0 1.84-1.6 3.334-3.572 3.334s-3.571-1.494-3.571-3.334v-4.666h7.143z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#hr_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    d: "M19.572 17.333c0 1.84-1.6 3.334-3.572 3.334s-3.571-1.494-3.571-3.334v-4.666h7.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.857 19.333h1.429v1.334h-1.429zm2.857 0h1.429v1.334h-1.429zM15.286 18h1.428v1.333h-1.428zm-1.429-1.333h1.429V18h-1.429zm2.857 0h1.429V18h-1.429zm-1.428-1.334h1.428v1.334h-1.428zM13.857 14h1.429v1.333h-1.429zm2.857 0h1.429v1.333h-1.429zm-1.428-1.333h1.428V14h-1.428zm2.857 0h1.429V14h-1.429zm0 2.666h1.429v1.334h-1.429zm0 2.667h1.429v1.333h-1.429zm-5.714 0h1.428v1.333H12.43zm0-2.667h1.428v1.334H12.43zm0-2.666h1.428V14H12.43z",
    clipRule: "evenodd"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D7D7D7",
    strokeWidth: 0.5,
    d: "M9.4 6.25h13.2c1.124 0 1.952 0 2.607.054.651.053 1.109.158 1.495.355a3.75 3.75 0 0 1 1.64 1.639c.196.386.301.844.354 1.495.054.655.054 1.483.054 2.607v7.2c0 1.124 0 1.952-.054 2.607-.053.651-.158 1.109-.355 1.495a3.75 3.75 0 0 1-1.639 1.64c-.386.196-.844.301-1.495.354-.655.054-1.483.054-2.607.054H9.4c-1.124 0-1.952 0-2.607-.054-.651-.053-1.109-.158-1.495-.355a3.75 3.75 0 0 1-1.64-1.639c-.196-.386-.301-.844-.354-1.495-.054-.655-.054-1.483-.054-2.607v-7.2c0-1.124 0-1.952.054-2.607.053-.651.158-1.109.355-1.495a3.75 3.75 0 0 1 1.639-1.64c.386-.196.844-.301 1.495-.354.655-.054 1.483-.054 2.607-.054Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hr_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 12.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 6 7.16 6 9.4 6h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C29 9.04 29 10.16 29 12.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C25.96 26 24.84 26 22.6 26H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 22.96 3 21.84 3 19.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hr_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 6h30v20H1z"
  })))));
};
export default SvgHr;